import React, { useCallback, useRef } from 'react'
import {
  Button,
  FormControl,
  FormLabel,
  HStack,
  IconButton,
  InputGroup,
  InputRightElement,
  Spacer,
  Text
} from '@chakra-ui/react'
import { CustomInput } from '../../ui/CustomInput'
import PropTypes from 'prop-types'
import CustomCheckbox from '../../ui/CustomCheckbox'
import { observer } from 'mobx-react'
import rootStore from '../../../store/RootStore'
import { FiX } from 'react-icons/fi'

const SearchForm = observer(({ onSubmit, inputProps }) => {
  const {
    searchStore: { searchText, setSearchText, invalidateSearch },
  } = rootStore

  const inputRef = useRef(null)
  const handleInputChange = e => {
    setSearchText(e.target.value)
  }
  const handleSubmit = useCallback(
    e => {
      if (e.type === 'keyup' && e.keyCode === 13) {
        onSubmit({ searchText: inputRef.current.value })
        inputRef.current.value = ''
      }
    },
    [onSubmit],
  )
  const handleInvalidateSearch = useCallback(() => {
    inputRef.current.value = ''
    invalidateSearch()
  }, [invalidateSearch])
  return (
    <FormControl onKeyUp={handleSubmit}>
      <FormLabel hidden>Search</FormLabel>
      <InputGroup>
        {searchText?.length > 0 ? (
          <InputRightElement>
            <IconButton
              variant="link"
              aria-label="clear-search"
              onClick={handleInvalidateSearch}>
              <FiX />
            </IconButton>
          </InputRightElement>
        ) : null}

        <CustomInput
          w="100%"
          title="Search"
          placeholder="For example: Performance"
          onChange={handleInputChange}
          defaultValue={searchText}
          ref={inputRef}
          {...inputProps}
        />
      </InputGroup>
    </FormControl>
  )
})

SearchForm.propTypes = {
  onSubmit: PropTypes.func,
  onChange: PropTypes.func,
  inputProps: PropTypes.any,
}

export const SearchFormActionBar = observer(({ onSubmit, ...props }) => {
  const {
    searchStore: { setSearchTitlesOnly, searchTitlesOnly, searchText },
  } = rootStore

  const handleCheck = useCallback(() => {
    setSearchTitlesOnly(!searchTitlesOnly)
  }, [searchTitlesOnly, setSearchTitlesOnly])

  return (
    <HStack
      {...props}
      w="100%">
      <CustomCheckbox onChange={handleCheck}>
        <Text textStyle="tinyHeader">Search in titles only</Text>
      </CustomCheckbox>
      <Spacer />
      <Button
        onClick={onSubmit}
        isDisabled={!searchText}
        title="Submit"
        size="sm"
        colorScheme="orange">
        Search
      </Button>
    </HStack>
  )
})
SearchFormActionBar.propTypes = {
  onSubmit: PropTypes.func,
  disableSubmitButton: PropTypes.bool,
}
export default SearchForm
